import { ArrowTopRightOnSquareIcon } from "@heroicons/react/16/solid";
import { generatePath, NavLink } from "react-router-dom";

import AddressDisplay from "~/components/address/AddressDisplay.tsx";
import CardValue from "~/components/Card/components/CardValue.tsx";
import Hint from "~/components/Hint";
import { CLIENT_CONTACT_PATH } from "~/constants/appRoutes.ts";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import type { Client } from "~/modules/client/api/client/clientTypes.ts";
import type { ClientContactPersonType } from "~/modules/client/api/clientContactPerson/clientContactPersonTypes.ts";

type Props = {
	className?: string
	client: Client;
	clientContactPerson: ClientContactPersonType;
	isSelfBilledInvoice: boolean;
};

const BillingSettingsContactPersonDisplay = ({ client, clientContactPerson, isSelfBilledInvoice }: Props) => {
	const address = clientContactPerson.hasDeviatingAddress ? clientContactPerson.ownAddress : client.address;

	const contactDetailsContent = <>
		<CardValue label="Name Kontaktperson">
			<NavLink className="flex items-center gap-x-1 hover:text-secondary-500"
					 to={generatePath(CLIENT_CONTACT_PATH, { contactId: clientContactPerson.id })}>
				{clientContactPerson.fullName}
				<ArrowTopRightOnSquareIcon className="ml-1 size-4" />
			</NavLink>
		</CardValue>
		<CardValue label="E-Mail"
				   enableCopyToClipboard={!!clientContactPerson.emailBusiness}>
			{clientContactPerson.emailBusiness || EMPTY_VALUE_PLACEHOLDER}
		</CardValue>
		<CardValue label="Telefon"
				   enableCopyToClipboard={!!(clientContactPerson.mobilePhone || clientContactPerson.phone)}>
			{clientContactPerson.mobilePhone || clientContactPerson.phone || EMPTY_VALUE_PLACEHOLDER}
		</CardValue>
	</>;

	if (isSelfBilledInvoice) {
		return <div className="grid grid-cols-2 gap-x-6 gap-y-4">
			{contactDetailsContent}
		</div>;
	}

	return <div className="grid grid-cols-2">
		<div className="space-y-4">
			{contactDetailsContent}
		</div>
		<div>
			<CardValue label="Rechnungsadresse"
					   enableCopyToClipboard={!!address}>
				{address ? <AddressDisplay address={address} name={client.displayName} /> :
					<Hint theme="error" size="sm">Es wurden keine Adressdaten für diese Kontaktperson oder deren Firma hinterlegt.</Hint>}
			</CardValue>
		</div>
	</div>;
};

export default BillingSettingsContactPersonDisplay;
